import { c as create_ssr_component, a as subscribe, b as add_attribute } from "./ssr.js";
import { p as page } from "./stores.js";
import { c as classNames, a as is_safari } from "./util.js";
const ImageEditor = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { src } = $$props;
  let { alt } = $$props;
  let { uploadPrompt = void 0 } = $$props;
  let { maxWidth } = $$props;
  let { maxHeight } = $$props;
  let { quality } = $$props;
  let { class: className = "" } = $$props;
  let overlayEl;
  let scale = 1;
  if ($$props.src === void 0 && $$bindings.src && src !== void 0)
    $$bindings.src(src);
  if ($$props.alt === void 0 && $$bindings.alt && alt !== void 0)
    $$bindings.alt(alt);
  if ($$props.uploadPrompt === void 0 && $$bindings.uploadPrompt && uploadPrompt !== void 0)
    $$bindings.uploadPrompt(uploadPrompt);
  if ($$props.maxWidth === void 0 && $$bindings.maxWidth && maxWidth !== void 0)
    $$bindings.maxWidth(maxWidth);
  if ($$props.maxHeight === void 0 && $$bindings.maxHeight && maxHeight !== void 0)
    $$bindings.maxHeight(maxHeight);
  if ($$props.quality === void 0 && $$bindings.quality && quality !== void 0)
    $$bindings.quality(quality);
  if ($$props.class === void 0 && $$bindings.class && className !== void 0)
    $$bindings.class(className);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $page.data.currentUser;
    $$rendered = ` <div${add_attribute(
      "class",
      classNames("hidden"),
      0
    )}${add_attribute("this", overlayEl, 0)}>${is_safari() ? `<span class="text-[#EF174C]" data-svelte-h="svelte-rat7gq">ATTENTION:</span> Use Google Chrome, Firefox, oder Microsoft Edge for
    optimized image quality and size.` : `Confirm with ENTER. Cancel with ESC.`} ${``}</div> ${``}  <div${add_attribute("style", `aspect-ratio: ${maxWidth}/${maxHeight}; scale: ${scale}`, 0)}${add_attribute("class", classNames("", "relative"), 0)}>${` <img${add_attribute("class", className + " cursor-pointer outline-[2px] hover:outline-dashed outline-[#EF174C] -outline-offset-[2px]", 0)}${add_attribute("src", src, 0)}${add_attribute("alt", alt, 0)}${add_attribute("title", uploadPrompt, 0)}>`}</div> <input class="w-px h-px opacity-0 fixed -top-40" type="file" accept="image/*" name="imagefile"> `;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  ImageEditor as default
};
